'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Tab = require('./Tab');

var _Tab2 = _interopRequireDefault(_Tab);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function renderChildren(children, selected, small) {
  return _react2.default.Children.map(children, function (child) {
    if (child.type === _Tab2.default) {
      return _react2.default.cloneElement(child, {
        small: small,
        selected: selected === child.key
      });
    }
    return child;
  });
}

var Tabs = function Tabs(_ref) {
  var children = _ref.children,
      selected = _ref.selected,
      small = _ref.small;

  return _react2.default.createElement(
    'ul',
    { className: 'Tabs' },
    renderChildren(children, selected, small)
  );
};

Tabs.propTypes = {
  children: _propTypes2.default.node,
  selected: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  small: _propTypes2.default.bool
};

Tabs.defaultProps = {
  children: null,
  selected: null,
  small: false
};

exports.default = Tabs;
Tabs.__docgenInfo = {
  'description': '',
  'methods': [],
  'displayName': 'Tabs',
  'props': {
    'children': {
      'defaultValue': {
        'value': 'null',
        'computed': false
      },
      'type': {
        'name': 'node'
      },
      'required': false,
      'description': ''
    },
    'selected': {
      'defaultValue': {
        'value': 'null',
        'computed': false
      },
      'type': {
        'name': 'union',
        'value': [{
          'name': 'string'
        }, {
          'name': 'number'
        }]
      },
      'required': false,
      'description': ''
    },
    'small': {
      'defaultValue': {
        'value': 'false',
        'computed': false
      },
      'type': {
        'name': 'bool'
      },
      'required': false,
      'description': ''
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/caligram-react/dist/components/Tabs.js
// module id = 615
// module chunks = 0